import { render, staticRenderFns } from "./collectionAccount.vue?vue&type=template&id=4d83cdd5&scoped=true"
import script from "./collectionAccount.vue?vue&type=script&lang=js"
export * from "./collectionAccount.vue?vue&type=script&lang=js"
import style0 from "./collectionAccount.vue?vue&type=style&index=0&id=4d83cdd5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d83cdd5",
  null
  
)

export default component.exports